import { ObjectType } from '@convergence/types';
import { AnalysisInputProps } from '../types';
import { AnalysisInputSwitch } from './analysis-input-switch';

export function AnalysisObjectInput(props: AnalysisInputProps<ObjectType>) {
  const fields = Object.entries(props.value._fields) ?? [];

  const order = props.value._order ?? Object.keys(props.value._fields);
  fields.sort((a, b) => order.indexOf(a[0]) - order.indexOf(b[0]));

  return (
    <div className="border-l mb-">
      <div className="font-bold mb-2">{props.name}</div>
      {fields.map(([key, value]) => (
        <div className="pl-4" key={key}>
          <AnalysisInputSwitch
            name={key}
            tree={props.tree}
            onChange={props.onChange}
            value={value}
            propertyPath={[...props.propertyPath, '_fields', key]}
            errors={props.errors}
          />
        </div>
      ))}
    </div>
  );
}
